// Format a number with spaces as thousands separator, e.g., 30 000 instead of 30000
export function formatNumber(num) {
  if (typeof num !== 'number' && typeof num !== 'string') return num;
  const n = Number(num);
  if (isNaN(n)) return num;
  return n.toLocaleString('en').replace(/,/g, '\u00A0');
}
